import React from "react";

type Props = {
  className?: string;
  children: React.ReactNode;
};

function Header({ className, children }: Props) {
  return <div className={`${className}`}>{children}</div>;
}

export default Header;
